const KEY = 'recentProducts';
const MAX = 10;

export const addRecentProduct = (product) => {
    const list = getRecentProducts().filter(p => p.productId !== product.productId);
    list.unshift(product);
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
};

export const getRecentProducts = () => {
    try {
        return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch {
        return [];
    }
};

export const clearRecentProducts = () => {
    localStorage.removeItem(KEY);
};